<ra-modal
    [title]="('document.edit.documentAccess.title' | translate)"
    [disabled]="loading()"
    (close)="close.emit()">

    <p class="ra-label-s content-secondary">{{ 'document.edit.documentAccess.subtitle' | translate }}</p>

    <!-- Adicionar e-mail avulso -->
    <div class="add-email-row">
        <ra-input
            [formControl]="newEmailControl"
            [type]="'email'"
            [leftIcon]="'email'"
            [placeholder]="('document.edit.documentAccess.addEmailPlaceholder' | translate)"
            (enterKeyPress)="addEmail()"
        />
        <ra-button
            [label]="'document.edit.documentAccess.addEmail' | translate"
            [type]="'primary-outline'"
            [disabled]="newEmailControl.invalid"
            (click)="addEmail()"
        />
    </div>

    @if (loadingMembers()) {
        <div class="access-loading">
            <ra-loading [size]="'small'" />
        </div>
    } @else {
        <div class="access-list">
            <!-- Membros da empresa -->
            @for (member of members(); track member._id) {
                <button type="button" class="access-item" (click)="toggleMember(member.email)">
                    <div class="access-data">
                        <p class="ra-label-s">{{ member.name }}</p>
                        <p class="ra-label-xs content-tertiary">{{ member.email }}</p>
                    </div>
                    <div class="access-check">
                        <ra-checkbox [ngModel]="isSelected(member.email)" [disabled]="true" />
                    </div>
                </button>
            }

            <!-- E-mails avulsos adicionados -->
            @for (extra of extraEmails(); track extra.email) {
                <div class="access-item access-item--static">
                    <div class="access-data">
                        <p class="ra-label-s">{{ extra.name || extra.email }}</p>
                        @if (extra.name) {
                            <p class="ra-label-xs content-tertiary">{{ extra.email }}</p>
                        }
                    </div>
                    <div class="access-actions">
                        <button type="button" class="access-action" (click)="editExtra(extra)">
                            <ra-icon icon="edit-2" varColor="contentSecondary" [size]="18" />
                        </button>
                        <button type="button" class="access-action" (click)="removeExtra(extra.email)">
                            <ra-icon icon="trash" varColor="accentRed" [size]="18" />
                        </button>
                    </div>
                </div>
            }

            @if (members().length === 0 && extraEmails().length === 0) {
                <p class="ra-label-s content-tertiary access-empty">
                    {{ 'document.edit.documentAccess.empty' | translate }}
                </p>
            }
        </div>
    }

    <div class="container-actions">
        <ra-button
            [label]="'common.save' | translate"
            [type]="'primary'"
            [loading]="loading()"
            [disabled]="loading() || loadingMembers()"
            (click)="onSave()"
        />
    </div>
</ra-modal>
